<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <page-header :headerName="'Lista de Assinasturas'" :showBtn="false" :btnName="''" :btnRoute="''"
                 :css="'container-fluid'"/>

    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
          <!-- Loading from page -->
          <full-loading v-if="loadingList"/>

          <!-- Filters -->
          <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Inicial</label>
                    <datepicker ref="programaticOpen3" v-model="dataSearch.init" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Final</label>
                    <datepicker ref="programaticOpen4" v-model="dataSearch.end" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Fatura gerada</label>
                    <select v-model="dataSearch.invoice" id="invoice" name="invoice">
                      <option value="">Todas</option>
                      <option value="true">Sim</option>
                      <option value="false">Não</option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="name">ID da empresa</label>
                    <input v-model="dataSearch.id" type="text" class="form-control" id="id" name="id">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="name">Nome da empresa</label>
                    <input v-model="dataSearch.name" type="text" class="form-control" id="name" name="name">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="name">E-mail da empresa ou financeiro</label>
                    <input v-model="dataSearch.email" type="text" class="form-control" id="email" name="email">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="closerName">Closer</label>
                    <input v-model="dataSearch.closerName" type="text" class="form-control" id="closerName"
                           name="closerName">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="cnpj">CNPJ</label>
                    <input v-model="dataSearch.cnpj" type="text" class="form-control" id="cnpj" name="cnpj">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="duration">Tipo</label>
                    <select v-model="dataSearch.type" id="duration" name="duration" required>
                      <option value="">Todos</option>
                      <option value="Mensal">Mensal</option>
                      <option value="Semestral">Semestral</option>
                      <option value="Bimestral">Bimestral</option>
                      <option value="Trimestral">Trimestral</option>
                      <option value="Anual">Anual</option>
                      <option value="BiAnual">BiAnual</option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="plan">Plano</label>
                    <select v-model="dataSearch.plan" id="plan" name="plan">
                      <option value="">Todos</option>
                      <option value="9">Todos</option>
                      <option value="1">Free</option>
                      <option value="0">Cliente em Teste</option>
                      <option value="2">Cliente até 10</option>
                      <option value="3">Cliente acima 10</option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Inicio Contrato</label>
                    <datepicker ref="programaticOpen6" v-model="dataSearch.contractinit" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar6()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Fim Contrato</label>
                    <datepicker ref="programaticOpen7" v-model="dataSearch.contractend" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar7()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <button v-on:click="searchData()">Pesquisar</button>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div v-if="!loadingList && isSearch && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
              <div class="portlet-title">
                <div class="caption">
                  <span class="caption-subject font-blue bold uppercase">Quantidade total ({{ totalItems }})</span>
                </div>
                <a v-on:click="downloadActualListExcel()" class="btn-all-excel right" title="Imprimir">
                  <span>Gerar Excel</span>
                  <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                </a>
              </div>

              <div class="portlet-body contate-table offset-top-20">
                <div class="table-scrollable table-scrollable-borderless">
                  <table class="table table-hover table-light table-icon">
                    <thead>
                    <tr>
                      <th> CLOSER</th>
                      <th> EMPRESA</th>
                      <th> INÍCIO<br/>EM</th>
                      <th> VÁLIDO<br/>ATÉ</th>
                      <th> PLANO</th>
                      <th> PLANO<br/>VENDIDO</th>
                      <th> CUSTO<br/>TOTAL</th>
                      <th> PRIMEIRO<br/>PAGAMENTO</th>
                      <th> MAX FUNC.<br/>NO PLANO</th>
                      <th> TOTAL DE<br/>FUNC.</th>
                      <th> RECORRENCIA<br/>DIA</th>
                      <th> NOTA</th>
                      <th> ÚLTIMO<br/>GERADO</th>
                      <th> ÚLTIMO<br/>PAGAMENTO</th>
                      <th> SITUAÇÃO</th>
                      <th> EMAIL</th>
                      <th> EMAIL FINANCEIRO</th>
                      <th> CONTRATO VÁLIDO</th>
                      <th> AÇÕES</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(c, index) in dataList">
                      <td>{{ c.userName }}</td>
                      <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.contextCode" target="_blank"
                             class="link">{{ c.name }}</a></td>
                      <td>{{ c.initDateStr }}</td>
                      <td>{{ c.contractValidUntilStr }}</td>
                      <td>{{ c.companyPlanStr }}</td>
                      <td>{{ c.planTypeStr }}</td>
                      <td>R$ {{ c.totalCost }}</td>
                      <td>R$ {{ c.firstPaymentPrice }}</td>
                      <td>{{ c.maxTotalEmployeeInContract }}</td>
                      <td>{{ c.totalEmployee }}</td>
                      <td>{{ c.recurringDayStr }}</td>
                      <td>
                        <span v-if="c.generateInvoice">Sim</span>
                        <span v-else>Não</span>
                      </td>
                      <td>{{ c.lastBankSlipGeneratedDateStr }}</td>
                      <td>{{ c.lastBankSlipPaidDateStr }}</td>
                      <td>
                        <span class="bg-error" v-bind:class="{'bg-warning': c.subscriptionStatusStr === 'Inadimplente',
                                    'bg-green': c.subscriptionStatusStr === 'Ativo',
                                    'bg-default': c.subscriptionStatusStr !== 'Ativo' &&
                                    c.subscriptionStatusStr !== 'Inadimplente'}">{{ c.subscriptionStatusStr }}
                        </span>
                      </td>
                      <td>{{ c.email }}</td>
                      <td>{{ c.financialEmail }}</td>
                      <td>{{ c.contractValidUntilStr }}</td>
                      <td>
                        <a v-on:click="switchSub(c, index)" class="btn-to-delete">
                          <span v-if="!c.generateInvoice">Habilitar</span>
                          <span v-if="c.generateInvoice">Desabilitar</span>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import {
  PAYMENT_HISTORIES_S,
  SWITCH_INVOICE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import {
  UTIL
} from "../../../../utils";

export default {
  name: "listSubscriptions",
  components: {
    topMenu,
    datepicker,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      loadingList: false,
      isSearch: false,
      totalItems: 0,
      ptBR: ptBR,
      dataSearch: {
        init: '',
        end: '',
        contractinit: '',
        contractend: '',
        invoice: '',
        id: '',
        name: '',
        email: '',
        r: '',
        p: '',
        closerName: '',
        cnpj: '',
        plan: '',
        type: ''
      },
      dataList: [{}]
    }
  },
  methods: {
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar6: function () {
      this.$refs.programaticOpen6.showCalendar();
    },
    openCalendar7: function () {
      this.$refs.programaticOpen7.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    mountUrl() {
      let url = PAYMENT_HISTORIES_S;
      url += "?p=1";
      url += "&r=300";

      if (this.dataSearch.cnpj)
        url += "&cnpj=" + this.dataSearch.cnpj;

      if (this.dataSearch.closerName)
        url += "&userName=" + this.dataSearch.closerName;

      if (this.dataSearch.plan)
        url += "&plan=" + this.dataSearch.plan;

      if (this.dataSearch.type)
        url += "&type=" + this.dataSearch.type;

      if (this.dataSearch.invoice)
        url += "&invoice=" + this.dataSearch.invoice;

      if (this.dataSearch.init)
        url += "&init=" + moment(this.dataSearch.init).format("YYYY-MM-DD");

      if (this.dataSearch.end)
        url += "&end=" + moment(this.dataSearch.end).format("YYYY-MM-DD");

      if (this.dataSearch.init)
        url += "&contractinit=" + moment(this.dataSearch.contractinit).format("YYYY-MM-DD");

      if (this.dataSearch.end)
        url += "&contractend=" + moment(this.dataSearch.contractend).format("YYYY-MM-DD");

      if (this.dataSearch.name)
        url += "&name=" + this.dataSearch.name;

      if (this.dataSearch.id)
        url += "&id=" + this.dataSearch.id;

      if (this.dataSearch.email)
        url += "&email=" + this.dataSearch.email;

      return url;
    },
    getList() {
      this.loadingList = true;
      this.failRequest = false;
      this.isSearch = true;
      REQUEST_SERVICE.get(this.mountUrl()).then((response) => {
        UTIL_SERVICE.console("RESULT PAYMENT_HISTORIES_S:", response.data);

        this.dataList = response.data.items;
        this.totalItems = response.data.totalItems;
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    switchSub(data) {
      REQUEST_SERVICE.requestContext('GET', SWITCH_INVOICE + data.id, data.contextCode).then((response) => {
        UTIL_SERVICE.console("RESULT SWITCH_INVOICE:", response.data);

        data.generateInvoice = !data.generateInvoice;
        swal("Aviso", response.data, "success");

      }).catch((reason) => {
        this.loadingList = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    searchData() {
      this.getList();
    },
    downloadActualListExcel() {
      let bodyValue = [];
      // this.dataList.map((value, index) => {
      //   bodyValue.push([value.userName, value.name, value.initDateStr, value.contractValidUntilStr, value.companyPlanStr, value.planTypeStr, value.totalCost, value.firstPaymentPrice, value.maxTotalEmployeeInContract, value.totalEmployee, value.recurringDayStr, value.generateInvoice, value.lastBankSlipGeneratedDateStr, value.lastBankSlipPaidDateStr, value.subscriptionStatusStr, value.zipCode, value.country, value.state, value.city, value.neighborhood, value.street, value.number, value.complement, value.cnpj, value.defaultQuantity, value.paymentMethod, value.paymentMethodStr, value.planType, value.pricePerEmployee, value.recurringDayToCharge, value.representationName, value.subscriptionStatus, value.totalEmployee, value.totalEmployeeFirstPayment, value.userId, value.companyId, value.id, value.contextCode]);

      this.dataList.filter((value, index) => {
        for (let line in value) {
          if (value[line] == undefined) {
            value[line] = "Não informado"
          }
        }
        bodyValue.push([value.userName, value.name, value.initDateStr, value.contractValidUntilStr, value.companyPlanStr, value.planTypeStr, value.totalCost, value.firstPaymentPrice, value.maxTotalEmployeeInContract, value.totalEmployee, value.recurringDayStr, value.generateInvoice, value.lastBankSlipGeneratedDateStr, value.lastBankSlipPaidDateStr, value.subscriptionStatusStr, value.email, value.financialEmail, value.zipCode, value.country, value.state, value.city, value.neighborhood, value.street, value.number, value.complement, value.cnpj, value.defaultQuantity, value.paymentMethod, value.paymentMethodStr, value.planType, value.pricePerEmployee, value.recurringDayToCharge, value.representationName, value.subscriptionStatus, value.totalEmployee, value.totalEmployeeFirstPayment, value.userId, value.companyId, value.id, value.contextCode, value.masterLink]);

        if (index + 1 === this.dataList.length) {
          let headValue = ["CLOSER", "EMPRESA", "INÍCIO", "VÁLIDO ATÉ", "PLANO", "PLANO VENDIDO", "CUSTO TOTAL", "PRIMEIRO PAGAMENTO", "MAX FUNC. NO PLANO", "TOTAL DE FUNC.", "RECORRENCIA DIA", "NOTA", "ÚLTIMO GERAD", "ÚLTIMO PAGAMENTO", "SITUAÇÃO", "EMAIL", "EMAIL FINANCEIRO", "CEP", "PAÍS", "ESTADO", "CIDADE", "BAIRRO", "RUA", "NUMERO", "COMPLEMENTO", "CNPJ", "QTD. INADIMPLENTE", "METODO DE PAGAMENTO(ID)", "METODO DE PAGAMENTO", "ID DO PLANO", "PRECO POR FUNC", "DIA DE RECORRENCIA", "RAZAO SOCIAL", "ID STATUS ASSINATURA", "TOTAL FUNC CADASTRADOS", "TOTAL FUNC 1º PAGAMENTO", "USER ID", "COMPANY ID", "ASSINATURA ID", "BANCO", "LINK DO DETALHES DA EMPRESA NO MASTER", "", "", "", "",];
          window.downloadListExcel(headValue, bodyValue, "Lista de Assinasturas");
        }
      });
    },
  },
  beforeMount() {
    if (UTIL.checkP(JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id) === false) {
      this.$router.push({
        path: '/'
      });
    }

    if (this.$route.params.companyId)
      this.dataSearch.id = this.$route.params.companyId;
  }
}
</script>

<style lang="scss">
.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}

.input-with-date {
  width: 100%;
}

.vdp-datepicker {
  input {
    width: 100%;
  }
}

.bg-error {
  background: #e71818 !important;
  padding: 2px 0;
  border-radius: 4px !important;
  color: #fff;
  width: 70px;
  display: inline-block;
  text-align: center;
}

.bg-warning {
  width: 100%;
  padding: 2px 8px;
  background: #c29d0b !important;
  border-radius: 4px !important;
  color: #fff;
  display: inline-block;
  text-align: center;
}

.bg-green {
  background: #00a651 !important;
  border-radius: 4px !important;
  color: #fff;
  width: 100%;
  padding: 2px 8px;
  display: inline-block;
  text-align: center;
}

.bg-default {
  background: #a5afbd !important;
  border-radius: 4px !important;
  color: #fff;
  width: 100%;
  padding: 2px 8px;
  display: inline-block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/invoiceHistory/listSubscriptions.vue